import React, { useEffect, useState } from "react";
import TopBar from "components/header/Normal/Topbar";
import { Link, useNavigate } from "react-router-dom";
import { HeaderLogoNew } from "assets/images/index";
import "./CivilServiceProgram.scss";
import { Input, Select } from "components/Form";
import OurCourses from "pages/home/Section/OurCourses";
import FacultiesList from "components/faculties-list/FacultiesList";
import { FaMapMarked, FaMobileAlt, FaTrophy, FaVideo } from "react-icons/fa";
import { FaBook } from "react-icons/fa";
import { FaClipboardCheck } from "react-icons/fa";
import { MdGroups } from "react-icons/md";
import { FaUserPlus } from "react-icons/fa";
import { FaBookReader } from "react-icons/fa";
import { FaTasks } from "react-icons/fa";
import { FaRegArrowAltCircleRight } from "react-icons/fa";
import { errorResponse, failResponse } from "config/config";
import { homeData, upcomingCourseData } from "services/home";
import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import { IoIosCall } from "react-icons/io";
import Testimonials from "components/testimonial/Testimonial";
// import playstore from "./images/Google_Play_Store_badge_EN.svg.webp";
// import appstore from "./images/Download_on_the_App_Store_Badge.svg.webp";
import { Courseimg1 } from "assets/images";
import { Calendarimg, Peopleimg } from "assets/icons";
import FAQ from "components/FAQs/FAQs";
import { sliderItem } from "config/utils";
import { Button, ListGroup, Modal, Nav, Tab } from "react-bootstrap";
import Slider from "react-slick";
import { countArray } from "config/utils";
import { momentDateFormat } from "config/utils";
import { BsArrowRight } from "react-icons/bs";
import { BiRupee } from "react-icons/bi";
import CourseSkeleton from "components/skeleton/CourseSkeleton";
import { GoogleMap, MarkerF, useJsApiLoader } from "@react-google-maps/api";
import { getMasterCenters } from "services/master";
import Footer from "components/footer/Footer";
import {
  Articleimg,
  HeaderLogo,
  GooglePlayStore,
  AppleAppStore,
} from "assets/images/index";
import { centerBasedLandingPage } from "services/center";
import toast from "react-hot-toast";

export default function CivilServiceProgram() {
  const [scroll, setScroll] = useState(false);
  const [regOpen, setRegOpen] = useState(true);
  const [mobileMenu, setMobileMenu] = useState(false);
  const [faculties, setFaculties] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 50);
    });
    document.body.classList.toggle("mobile_open", mobileMenu);
  }, [mobileMenu]);

  // --------------- getting all home page data ----------------//
  React.useLayoutEffect(() => {
    const getHomeData = async () => {
      try {
        setLoading(true);
        const res = await homeData({ type: "home" });

        if (res.code === 200) {
          setFaculties(res.data.faculties.rows || []);
          setTestimonials(res.data.testimonial.rows || []);
          setLoading(false);
        } else {
          failResponse(res);
          setLoading(false);
        }
      } catch (err) {
        errorResponse(err);
        setLoading(false);
      }
    };

    // calls all the master functions
    getHomeData();

    // eslint-disable-next-line
  }, []);

  // ******************************************* Our Courses *************************************************
  const [allSubjects, setAllSubjects] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState("");

  const [selectedCourses, setSelectedCourses] = useState([]);

  var Coursecard = {
    dots: true,
    arrows: true,
    slidesToShow: sliderItem(selectedCourses, 5),
    // slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    speed: 900,
    autoplay: true,
    autoplaySpeed: 8000,
    // variableWidth: true,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: sliderItem(selectedCourses, 4),
          // slidesToShow: 3,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 801,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  };
  var CoursecardTitle = {
    dots: false,
    arrows: true,
    slidesToShow: sliderItem(allSubjects, 5),
    slidesToScroll: 2,
    infinite: true,
    speed: 900,
    autoplaySpeed: 8000,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 801,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },

      {
        breakpoint: 575,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };

  const getMainUpcomingCourse = async () => {
    try {
      setLoading(true);
      const res = await upcomingCourseData({ exam_id: selectedSubject });

      if (res.code === 200) {
        setSelectedSubject(res.data.examTypes[0]?.id || "");
        setAllSubjects(res.data.examTypes || []);
        setSelectedCourses(res.data.courses || []);
        setLoading(false);
      } else {
        failResponse(res);
      }
    } catch (err) {
      errorResponse(err);
    }
  };

  // --------------- getting course according to subject ----------------//
  React.useLayoutEffect(() => {
    getMainUpcomingCourse();
    // eslint-disable-next-line
  }, []);

  // --------------- getting course according to subject ----------------//
  React.useEffect(() => {
    const getUpcomingCourse = async () => {
      try {
        setLoading(true);
        const res = await upcomingCourseData({ exam_type_id: selectedSubject });

        if (res.code === 200) {
          setSelectedCourses(res.data.courses || []);
          setLoading(false);
        } else {
          failResponse(res);
        }
      } catch (err) {
        errorResponse(err);
      }
    };

    selectedSubject && getUpcomingCourse();
  }, [selectedSubject]);

  // ********************************************************************************************
  // ******************************************* Visit Us *************************************************
  const [allCenters, setAllCenters] = useState([]);

  const containerStyle = {
    width: "100%",
    height: "100%",
  };

  var myStyles = [
    {
      featureType: "poi",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
  ];
  const mapOptions = {
    streetViewControl: false,
    mapTypeControl: false,
    styles: myStyles,
    zoom: 15,
  };

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP,
  });

  const [, setMap] = React.useState(null);
  const [index, setIndex] = React.useState(0);

  const onMapLoad = React.useCallback(function callback(map) {
    const bounds = new window.google.maps.LatLngBounds({
      lat: +allCenters[index]?.latitude || 28.535517,
      lng: +allCenters[index]?.longitude || 77.391029,
    });
    map.fitBounds(bounds);

    setMap(map);
    // eslint-disable-next-line
  }, []);

  const onMarkerLoad = (marker) => { };

  // --------------- getting all required masters data ----------------//
  React.useLayoutEffect(() => {
    const getCentersData = async () => {
      try {
        const res = await getMasterCenters();
        if (res.code === 200) {
          setAllCenters(res.data.centerPage || []);
        } else {
          failResponse(res);
        }
      } catch (err) {
        errorResponse(err);
      }
    };

    // calls all the master functions
    getCentersData();
    // eslint-disable-next-line
  }, []);
  // ********************************************************************************************
  // ******************************************* Modals *************************************************
  const [showSyllabus, setShowSyllabus] = useState(false);
  const [heading, setHeading] = useState("");
  const [showFeatures, setShowFeatures] = useState(false);
  const [showPath, setShowPath] = useState(false);
  // ********************************************************************************************
  const [data, setData] = useState({});
  const [errorField, setErrorField] = useState({});

  // ******************************************* Faq  *************************************************
  const [faqs, setFaqs] = useState([]);
  const [type, settype] = useState("center");
  const navigate = useNavigate();
  // --------------- getting all required masters data ----------------//
  React.useLayoutEffect(() => {
    const getCentersData = async () => {
      try {
        setLoading(true);

        // Proceed with fetching data based on the determined mainId
        const res = await centerBasedLandingPage(
          type === "center" ? { centerpageId: 4 } : { verticleId: 4 }
        );

        if (res.code === 200) {
          const { centerFaq } = res.data;
          setFaqs(centerFaq || []);
          setLoading(false);
        } else {
          failResponse(res);
          setLoading(false);
        }
      } catch (err) {
        errorResponse(err);
        setLoading(false);
      }
    };

    // calls all the master functions
    getCentersData();
    // eslint-disable-next-line
  }, []);

  // ********************************************************************************************

  // ********************************************* Register form submit ***********************************************
  //*********************Handel Validation********************************** */
  const handleValidation = () => {
    let errorField = {};
    let formIsValid = true;

    if (!data.name) {
      errorField["name"] = "Please Enter Name";
      formIsValid = false;
    }
    if (!data.email) {
      errorField["email"] = "Please Enter Email";
      formIsValid = false;
    }

    if (!data.mobile) {
      errorField["mobile"] = "Please Enter Mobile";
      formIsValid = false;
    }
    if (!data.city) {
      errorField["city"] = "Please Enter City";
      formIsValid = false;
    }
    if (!data.year) {
      errorField["year"] = "Please Select Year";
      formIsValid = false;
    }
    setErrorField(errorField);
    return formIsValid;
  };

  const handleSubmit = () => {
    if (handleValidation()) {
      // setSubmitLoading(true);
      try {
        // const formData = new FormData();
        // const finalData = {
        //   firstname: data.firstName,
        //   lastname: data.lastName,
        //   emailid: data.emailId,
        //   mobile: data.mobile,
        //   address: data.address,
        // };
        // // Add image file
        // formData.append("studentphoto", profileImage); // Assuming `data.image` is a File object
        // // Append encrypted data
        // formData.append(
        //   "reqData",
        //   encryptData({ ...finalData, access_token: cookies })
        // );
        // const res = await addStudent(formData);
        // if (res.code === 200) {
        //   toast.success(res.message);
        //   navigate(-1);
        // } else {
        //   toast.error(res.message);
        // }
      } catch (err) {
        toast.error(err?.response?.data?.message || err.message);
      }
      // setSubmitLoading(false);
    } else {
      toast.error("Please fill all the fields");
    }
  };

  // ********************************************************************************************

  return (
    <>
      <div className="NewContent">
        {/* <div className={`header_wrapper ${scroll ? "scrollheader" : ""}`}> */}
        <div className={`header_wrapper ${scroll ? "scrollheader" : ""}`}>
          <header className="header">
            <div className="container">
              <div className="logo">
                <Link to="/">
                  <img src={HeaderLogoNew} alt="Shubra ranjan" loading="lazy" />
                </Link>
              </div>
              <div className="mobile-container">
                <div className="mobile-icon">
                  <span>
                    <IoIosCall />
                  </span>
                </div>
                <div className="mobile-number"> 9810212719</div>
              </div>
            </div>
          </header>
        </div>

        <div
          className={
            regOpen ? "register-container active" : "register-container"
          }
        >
          <div
            onClick={() => setRegOpen(!regOpen)}
            className="register-drawer-icon"
          >
            <span>
              {regOpen ? (
                <IoIosArrowForward style={{ fontSize: "50px" }} />
              ) : (
                <IoIosArrowBack style={{ fontSize: "40px" }} />
              )}
            </span>
          </div>
          <div className="register-drawer-content">
            <div className="register-forn">
              <h1>Register</h1>
              <div className="input-container">
                <input
                  type="text"
                  name="name"
                  onChange={(e) => {
                    const { name, value } = e.target;
                    setData({ ...data, [name]: value });
                  }}
                  className={
                    !errorField.name
                      ? `input form-control `
                      : `input form-control input-error `
                  }
                  placeholder="Enter Name"
                />
                {/* <div className="error">ERROR</div> */}
              </div>
              <div className="input-container">
                <input
                  type="text"
                  name="mobile"
                  onChange={(e) => {
                    const { name, value } = e.target;
                    setData({ ...data, [name]: value });
                  }}
                  className={
                    !errorField.mobile
                      ? `input form-control `
                      : `input form-control input-error `
                  }
                  placeholder="Enter Mobile Number"
                />
                {/* <div className="error">ERROR</div> */}
              </div>
              <div className="input-container">
                <input
                  type="text"
                  name="email"
                  onChange={(e) => {
                    const { name, value } = e.target;
                    setData({ ...data, [name]: value });
                  }}
                  className={
                    !errorField.email
                      ? `input form-control `
                      : `input form-control input-error `
                  }
                  placeholder="Enter Email"
                />
                {/* <div className="error">ERROR</div> */}
              </div>
              <div className="input-container">
                <input
                  type="text"
                  name="city"
                  onChange={(e) => {
                    const { name, value } = e.target;
                    setData({ ...data, [name]: value });
                  }}
                  className={
                    !errorField.city
                      ? `input form-control `
                      : `input form-control input-error `
                  }
                  placeholder="Enter City"
                />
                {/* <div className="error">ERROR</div> */}
              </div>
              <div className="form_field">
                <Select
                  name="year"
                  placeholder="Select Target Year"
                  onChange={(e) => {
                    const { name, value } = e.target;
                    setData({ ...data, [name]: value });
                  }}
                  className={
                    !errorField.year
                      ? `input form-control `
                      : `input form-control input-error `
                  }
                >
                  <option value="">{"Select Target Year"}</option>
                  {Array.from({ length: 11 }, (_, i) => {
                    const currentYear = new Date().getFullYear();
                    const year = currentYear - 5 + i;
                    return (
                      <option value={year} key={year}>
                        {year}
                      </option>
                    );
                  })}
                </Select>
              </div>
              <div className="button-container">
                <button onClick={handleSubmit}>submit</button>
              </div>
            </div>
          </div>
        </div>

        {/* **************************************** Our Courses **************************************** */}
        <section class="hero">
          <h1>Crack UPSC Civil Services in 1st Attempt</h1>
          <p>Join Shubhra Ranjan IAS Study for Expert Guidance</p>
        </section>

        {/* ******************************************************************************** */}
        {/* **************************************** Our Courses **************************************** */}
        {allSubjects?.length > 0 && (
          <div className="exam_courses">
            <div className="container">
              <div className="page_title padding">
                <h3>Our Courses </h3>
                {/* <p>
                Meet these shining stars who made it at the top and are proud to
                pe called toppers of there exams.
              </p> */}
              </div>

              <div className="courses_categories">
                <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                  <div className="courseTitle">
                    <Nav variant="pills" className="" activeKey={true}>
                      <Slider {...CoursecardTitle}>
                        {allSubjects &&
                          allSubjects.map(({ id, title }) => {
                            return (
                              <Nav.Item
                                key={id}
                                onClick={() => setSelectedSubject(id)}
                              >
                                <Nav.Link
                                  eventKey={id}
                                  className={
                                    selectedSubject === id
                                      ? "active"
                                      : "inactive"
                                  }
                                >
                                  {title}
                                </Nav.Link>
                              </Nav.Item>
                            );
                          })}
                      </Slider>
                    </Nav>
                  </div>
                  <div className="navtab_content">
                    <Tab.Content>
                      <Tab.Pane
                        eventKey={selectedSubject}
                        active={true}
                        activekey={selectedSubject}
                      >
                        {/************** loading component **************/}
                        {loading && (
                          <div className="d-flex">
                            {countArray(4).map((data) => {
                              return (
                                <div className="w-25 mx-1" key={data}>
                                  <CourseSkeleton width="100%" height={390} />
                                </div>
                              );
                            })}
                          </div>
                        )}

                        {/************** not found component **************/}
                        {!loading && selectedCourses.length <= 0 && (
                          <div className="coursecard_wrap">
                            <div className="content text-center text-danger py-5">
                              <h6>No Course Available</h6>
                            </div>
                          </div>
                        )}

                        {/************** main component **************/}
                        {!loading && selectedCourses.length > 0 && (
                          <div className="coursecard_wrap">
                            <Slider {...Coursecard}>
                              {selectedCourses.map(({ BillingCourse }, i) => {
                                return (
                                  <div className="course_card" key={i}>
                                    <div className="image_wrap">
                                      <img
                                        src={BillingCourse?.image || Courseimg1}
                                        alt={BillingCourse?.CourseTitle}
                                      />
                                    </div>
                                    <div className="content">
                                      <div className="course_detail">
                                        <h5>{BillingCourse?.CourseTitle}</h5>
                                        <ul>
                                          <li>
                                            <img
                                              src={Calendarimg}
                                              alt=""
                                              loading="lazy"
                                            />
                                            Starting from
                                            <b>
                                              {momentDateFormat(
                                                BillingCourse?.CourseStartDate
                                              )}
                                            </b>
                                          </li>
                                          <li>
                                            <img
                                              src={Peopleimg}
                                              alt=""
                                              loading="lazy"
                                            />
                                            {BillingCourse?.CourseType ===
                                              "Both"
                                              ? "Hybrid"
                                              : BillingCourse?.CourseType}
                                          </li>
                                          {/* <li>
                                          <img src={Pageimg} alt="" />
                                          26 Lectures (Static)
                                        </li> */}
                                          <li>
                                            <h6 className="price">
                                              <BiRupee />
                                              {
                                                BillingCourse?.SRNewStudentCourseFee
                                              }
                                              /-
                                            </h6>
                                            <span>Inclusive of taxes</span>
                                          </li>
                                        </ul>
                                      </div>
                                      <div className="button_wrap">
                                        <Link
                                          // to={`/course-detail/${BillingCourse?.CourseTitle}/${BillingCourse?.id}`}
                                          to={
                                            BillingCourse?.id ===
                                              "7f77e12b-c186-4934-9bfc-abf3f3ff4a28"
                                              ? `/courses/modular-courses/NCERT-foundation-course`
                                              : BillingCourse?.id ===
                                                "f64976d1-9cda-45a2-aa84-13fc66534315"
                                                ? `/courses/psir-courses/psir-optional-classroom-course`
                                                : BillingCourse?.id ===
                                                  "ee52f2c9-6e82-4c89-b6ca-01f13b6335e9"
                                                  ? `/courses/psir-courses/psir-answer-writing-module`
                                                  : BillingCourse?.id ===
                                                    "2e87fe0b-1f18-4aad-aac8-ad3fb389c0e2"
                                                    ? `/courses/psir-courses/psir-optional-online-course`
                                                    : BillingCourse?.id ===
                                                      "5457a2b8-6314-4b32-8c61-0d750382104e"
                                                      ? `/courses/psir-courses/psir-on-demand-tablet-course`
                                                      : BillingCourse?.id ===
                                                        "280e4431-6460-463c-aace-081bc8c4cce7"
                                                        ? `/courses/psir-courses/psir-postal-correspondence-course`
                                                        : BillingCourse?.id ===
                                                          "22f0178d-e5be-4d1d-a524-ff247f882c47"
                                                          ? `/history-optional-classroom-course`
                                                          : BillingCourse?.id ===
                                                            "d22dea14-d7ce-4e06-a972-f9c3ef6518a3"
                                                            ? `/history-optional-online-course`
                                                            : BillingCourse?.id ===
                                                              "56801f1b-ff6d-407e-b4a6-3a53d1f3a7b0"
                                                              ? `/courses/sociology-courses/sociology-optional-classroom-course`
                                                              : BillingCourse?.id ===
                                                                "7e316a86-a888-4794-aef5-b4a69766e825"
                                                                ? `/courses/sociology-courses/sociology-optional-online-course`
                                                                : BillingCourse?.id ===
                                                                  "31547019-950b-41a1-9d38-3b9a455b0904"
                                                                  ? `/courses/sociology-courses/sociology-on-demand-tablet-course`
                                                                  : BillingCourse?.id ===
                                                                    "9be8b42a-ea81-4f5b-8cb5-18b0e57b1c3e"
                                                                    ? `/courses/sociology-courses/sociology-test-series`
                                                                    : BillingCourse?.id ===
                                                                      "0d04b1e8-4b67-44aa-8a54-afdafae1d7cf"
                                                                      ? `/courses/gs-courses/gs-foundation-classroom-course`
                                                                      : BillingCourse?.id ===
                                                                        "2269626d-c63f-4cdf-b270-1285c4c3f11e"
                                                                        ? `/courses/gs-courses/gs-foundation-online-course`
                                                                        : BillingCourse?.id ===
                                                                          "a5db0ae6-f2b0-4de6-a4ac-356262aea68d"
                                                                          ? `/courses/gs-courses/qep-gs-crash-course-classroom`
                                                                          : BillingCourse?.id ===
                                                                            "b0f96a3d-250a-4769-bdff-3e223df65efd"
                                                                            ? `/courses/gs-courses/qep-gs-crash-course-online`
                                                                            : BillingCourse?.id ===
                                                                              "06f634ce-d49a-4327-bd9e-fc412d3f0e48"
                                                                              ? `/courses/gs-courses/Integrated-GS-and-PSIR-Optional-Classroom-Course`
                                                                              : BillingCourse?.id ===
                                                                                "66a37d9f-abd6-4822-b56d-559db8a9cc63"
                                                                                ? `/courses/gs-courses/Integrated-GS-and-Sociology-Optional-Classroom-Course`
                                                                                : BillingCourse?.id ===
                                                                                  "69204890-d049-4521-9f0d-594b1d624d4c"
                                                                                  ? `/Integrated-GS-and-History-Optional-Classroom-Course`
                                                                                  : BillingCourse?.id ===
                                                                                    "dbb6e35d-f703-4778-8157-6b3c89ecb343"
                                                                                    ? `/courses/gs-courses/Integrated-GS-and-PSIR-Optional-Online-Course`
                                                                                    : BillingCourse?.id ===
                                                                                      "df9db5b3-e8f1-428e-885c-68c91747e9c0"
                                                                                      ? `/courses/gs-courses/Integrated-GS-and-Sociology-Optional-Online-Course`
                                                                                      : BillingCourse?.id ===
                                                                                        "84f8cf5d-482e-42ec-a49a-b00f434ecf57"
                                                                                        ? `/Integrated-GS-and-History-Optional-Online-Course`
                                                                                        : BillingCourse?.id ===
                                                                                          "bd04e35a-8620-465e-bc4a-b2b516cdbfb4"
                                                                                          ? `/courses/modular-courses/CSAT-foundation-course`
                                                                                          : BillingCourse?.id ===
                                                                                            "53a90166-3367-45b1-b950-70bc3f41187b"
                                                                                            ? `/courses/modular-courses/essay-program`
                                                                                            : BillingCourse?.id ===
                                                                                              "6b3ff0a9-49c7-42ce-a703-6274bc2d3dae"
                                                                                              ? `/gs-mentorship-program`
                                                                                              : BillingCourse?.id ===
                                                                                                "5cf9d9f8-a8c9-4c5a-b403-1ed1cdcd4c2b"
                                                                                                ? `/gs-mentorship-online-program`
                                                                                                : BillingCourse?.id ===
                                                                                                  "28e68130-8e23-4893-97e1-54880dd2e031"
                                                                                                  ? `/psir-mentorship-program`
                                                                                                  : BillingCourse?.id ===
                                                                                                    "03d608ab-5ae5-4839-b736-591c0ac0bcea"
                                                                                                    ? `/psir-optional-video-batch`
                                                                                                    : BillingCourse?.id ===
                                                                                                      "1c5e7800-9a77-4e74-9ba9-b177377db789"
                                                                                                      ? `/polity-pyq-course`
                                                                                                      : BillingCourse?.id ===
                                                                                                        "6211b29a-1754-4116-a255-6a02e196cdbc"
                                                                                                        ? `/psir-mentorship-online-program`
                                                                                                        : BillingCourse?.id ===
                                                                                                          "77181a27-eaeb-44aa-8164-e8163ef71633"
                                                                                                          ? `/political-science-and-ir-optional-classroom-course`
                                                                                                          : BillingCourse?.id ===
                                                                                                            "5cc30889-6e13-4008-ac0f-df79a0e0e97a"
                                                                                                            ? `/political-science-and-ir-optional-online-course`
                                                                                                            : BillingCourse?.id ===
                                                                                                              "c8c46cf8-f7d7-4cab-9251-8a962df982b9"
                                                                                                              ? `/environment-module-classroom`
                                                                                                              : BillingCourse?.id ===
                                                                                                                "2519ab6f-113f-43c3-ab18-0c92cebd4bee"
                                                                                                                ? `/environment-module-online`
                                                                                                                : BillingCourse?.id ===
                                                                                                                  "6b66095d-eded-4a16-a456-b84683c00372"
                                                                                                                  ? `/science-technology-classroom`
                                                                                                                  : BillingCourse?.id ===
                                                                                                                    "23bcdea2-5aac-45c6-8b78-ccf1feb4bec1"
                                                                                                                    ? `/science-technology-online`
                                                                                                                    : BillingCourse?.id === "44d7f0b7-b093-4bce-a6b6-1f2d73af7129"
                                                                                                                      ? `/psir-optional-mains-crash-course-upsc`
                                                                                                                      : BillingCourse?.id === "875e22db-422a-4d2f-a333-7abac13da38d"
                                                                                                                        ? "/courses/psir-courses/psir-answer-writing-module-sectional-tests"
                                                                                                                        : BillingCourse?.id === "3fb0ced8-98d3-4094-993c-7705eae8e37a"
                                                                                                                          ? "/courses/sociology-courses/sociology-mission1250-upsc-online-course"
                                                                                                                          : BillingCourse?.id === "3b5e55d8-897c-415e-807b-d460524c4f25"
                                                                                                                            ? "/courses/sociology-courses/sociology-mission1250-upsc-classroom-course"
                                                                                                                            : BillingCourse?.id === "f7a29a3b-b7fd-4b63-8df3-caa87496079d"
                                                                                                                              ? "/courses/gs-courses/gs-paper2-modular-course"
                                                                                                                              : BillingCourse?.id === "01f9b68c-4b5b-4cd5-b403-0ed7a6545c39"
                                                                                                                                ? "/course-detail/gs-answer-writing-module-year-long-target-2026"
                                                                                                                                : BillingCourse?.id === "724f0f0b-458e-4940-a2b4-bba4618ed596"
                                                                                                                                  ? "/courses/gs-courses/rise-mentorship"
                                                                                                                                  : BillingCourse?.id === "01f9b68c-4b5b-4cd5-b403-0ed7a6545c39"
                                                                                                                                    ? "/freeresources/fr-mains-gs-paper-2"
                                                                                                                                    : BillingCourse?.id === "b9dcb62f-433a-479a-a6ea-08e3b5dd1010"
                                                                                                                                      ? "/course-detail/rise-gs-psir-mission-1250-course"
                                                                                                                                      : BillingCourse?.id === "77181a27-eaeb-44aa-8164-e8163ef71633"
                                                                                                                                        ? "/course-detail/psir-classroom-course-6-months-target-2026"
                                                                                                                                        : BillingCourse?.id === "0d04b1e8-4b67-44aa-8a54-afdafae1d7cf"
                                                                                                                                          ? "/course-detail/gs-prelims-cum-mains-classroom-course"
                                                                                                                                          : BillingCourse?.id === "01f9b68c-4b5b-4cd5-b403-0ed7a6545c39"
                                                                                                                                            ? "/course/gs-answer-writing-module-2026"
                                                                                                                                            : `/course-detail/${BillingCourse?.CourseTitle}/${BillingCourse?.id}`
                                          }
                                          className="button"
                                        >
                                          Enroll Now
                                          <span className="icon">
                                            <BsArrowRight />
                                          </span>
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </Slider>

                            {/* <div className="button_wrap upcom_course">
                              <Link to="/course-listing" className="button">
                                View all courses
                                <span className="icon">
                                  <BsArrowRight />
                                </span>
                              </Link>
                            </div> */}
                          </div>
                        )}
                      </Tab.Pane>
                    </Tab.Content>
                  </div>
                </Tab.Container>
              </div>
            </div>
          </div>
        )}
        {/* ******************************************************************************** */}

        {/* <!-- Syllabus Section --> */}
        <section class="syllabus">
          <div className="container">
            <div className="page_title">
              <h3>Comprehensive Syllabus</h3>
            </div>
            <div class="syllabus-grid">
              <div class="syllabus-card">
                <h3>Prelims</h3>
                <ul>
                  <li
                    onClick={() => {
                      setHeading("General Studies Paper I");
                      setShowSyllabus(true);
                    }}
                  >
                    General Studies Paper I
                  </li>
                  <li
                    onClick={() => {
                      setHeading("CSAT Paper II");
                      setShowSyllabus(true);
                    }}
                  >
                    CSAT Paper II
                  </li>
                  <li
                    onClick={() => {
                      setHeading("Current Affairs");
                      setShowSyllabus(true);
                    }}
                  >
                    Current Affairs
                  </li>
                </ul>
              </div>
              <div class="syllabus-card">
                <h3>Mains</h3>
                <ul>
                  <li
                    onClick={() => {
                      setShowSyllabus(true);
                      setHeading("GS Papers I-IV");
                    }}
                  >
                    GS Papers I-IV
                  </li>
                  <li
                    onClick={() => {
                      setHeading("Essay Writing");
                      setShowSyllabus(true);
                    }}
                  >
                    Essay Writing
                  </li>
                  <li
                    onClick={() => {
                      setHeading("Optional Subjects");
                      setShowSyllabus(true);
                    }}
                  >
                    Optional Subjects
                  </li>
                </ul>
              </div>
              <div class="syllabus-card">
                <h3>Interview</h3>
                <ul>
                  <li
                    onClick={() => {
                      setHeading("Personality Test");
                      setShowSyllabus(true);
                    }}
                  >
                    Personality Test
                  </li>
                  <li
                    onClick={() => {
                      setHeading("Mock Interviews");
                      setShowSyllabus(true);
                    }}
                  >
                    Mock Interviews
                  </li>
                  <li
                    onClick={() => {
                      setHeading("Expert Guidance");
                      setShowSyllabus(true);
                    }}
                  >
                    Expert Guidance
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* <!-- Course Features --> */}
        <section class="features">
          <div className="container">
            <div className="page_title">
              <h3>Course Features</h3>
            </div>
            <div class="features-grid">
              <div
                class="feature-card"
                onClick={() => {
                  setHeading("Live Classes");
                  setShowFeatures(true);
                }}
              >
                <div className="feature-icon">
                  <FaVideo />
                </div>
                <div className="feature-heading">
                  <h3>Live Classes</h3>
                </div>
              </div>
              <div
                class="feature-card"
                onClick={() => {
                  setHeading("Study Material");
                  setShowFeatures(true);
                }}
              >
                <div className="feature-icon">
                  <FaBook />
                </div>
                <div className="feature-heading">
                  <h3>Study Material</h3>
                </div>
              </div>
              <div
                class="feature-card"
                onClick={() => {
                  setHeading("Test Series");
                  setShowFeatures(true);
                }}
              >
                <div className="feature-icon">
                  <FaClipboardCheck />
                </div>
                <div className="feature-heading">
                  <h3>Test Series</h3>
                </div>
              </div>
              <div
                class="feature-card"
                onClick={() => {
                  setHeading("Doubt Sessions");
                  setShowFeatures(true);
                }}
              >
                <div className="feature-icon">
                  <MdGroups />
                </div>
                <div className="feature-heading">
                  <h3>Doubt Sessions</h3>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <!-- Customer Journey --> */}
        <section class="journey">
          <div className="container">
            <div className="page_title">
              <h3>Your Path to UPSC Success</h3>
            </div>

            <div class="journey-grid">
              {/* <div class="journey-step">
                <div className="journey-heading">
                  <div className="journey-icon">
                    <FaUserPlus />
                  </div>
                  <div className="journey-title">
                    <h3>Register</h3>
                  </div>
                </div>
                <div className="journey-desc">
                  <p>Sign up for your chosen course</p>
                </div>
              </div> */}
              <div
                class="journey-step"
                onClick={() => {
                  setHeading("Learn");
                  setShowPath(true);
                }}
              >
                <div className="journey-heading">
                  <div className="journey-icon">
                    <FaBookReader />
                  </div>
                  <div className="journey-title">
                    <h3>Learn</h3>
                  </div>
                </div>
                <div className="journey-desc">
                  <p>Access quality study material</p>
                </div>
              </div>
              <div
                class="journey-step"
                onClick={() => {
                  setHeading("Practice");
                  setShowPath(true);
                }}
              >
                <div className="journey-heading">
                  <div className="journey-icon">
                    <FaTasks />
                  </div>
                  <div className="journey-title">
                    <h3>Practice</h3>
                  </div>
                </div>
                <div className="journey-desc">
                  <p>Regular tests and assignments</p>
                </div>
              </div>
              <div
                class="journey-step"
                onClick={() => {
                  setHeading("Succeed");
                  setShowPath(true);
                }}
              >
                <div className="journey-heading">
                  <div className="journey-icon">
                    <FaTrophy />
                  </div>
                  <div className="journey-title">
                    <h3>Succeed</h3>
                  </div>
                </div>
                <div className="journey-desc">
                  <p>Achieve your UPSC goals</p>
                </div>

                {/* <div className="next-icon">
                  <RiArrowRightDoubleFill/>
                </div> */}
              </div>
            </div>
          </div>
        </section>

        <FacultiesList faculties={faculties} loading={loading} />

        {/* <!-- Testimonials Section --> */}
        {/* <section class="testimonials">
          <div className="container">
            <div className="page_title">
              <h3>Topper Testimonials</h3>
            </div>

            <div class="testimonial-slider">
              <div class="testimonial-card">
                <img src="https://via.placeholder.com/100" alt="Anil" />
                <h3>Anil</h3>
                <p>"The faculty's guidance was instrumental in my success"</p>
              </div>
              <div class="testimonial-card">
                <img src="https://via.placeholder.com/100" alt="Mukesh" />
                <h3>Mukesh</h3>
                <p>"Excellent study material and mentorship"</p>
              </div>
              <div class="testimonial-card">
                <img src="https://via.placeholder.com/100" alt="Suresh" />
                <h3>Suresh</h3>
                <p>"Best UPSC coaching experience"</p>
              </div>
              <div class="testimonial-card">
                <img src="https://via.placeholder.com/100" alt="Sonam" />
                <h3>Sonam</h3>
                <p>"Highly recommended for UPSC aspirants"</p>
              </div>
              <div class="testimonial-card">
                <img src="https://via.placeholder.com/100" alt="Kunal" />
                <h3>Kunal</h3>
                <p>"Great learning environment and support"</p>
              </div>
            </div>
          </div>
        </section> */}
        <Testimonials testimonials={testimonials} loading={loading} />
        <FAQ loading={loading} faqs={faqs} />
        {/* <!-- App Download Section --> */}
        <section class="app-download">
          <div className="container">
            <div className="page_title">
              <h3>Download Our App</h3>
            </div>

            <p>Study on the go with our mobile app</p>
            <div class="app-buttons">
              <a href="#" class="app-button">
                {/* <img
                  src="https://via.placeholder.com/150x50"
                  alt="Play Store"
                /> */}
                <img src={GooglePlayStore} alt="Play Store" style={{ borderRadius: "6px" }} />
              </a>
              <a href="#" class="app-button">
                {/* <img src="https://via.placeholder.com/150x50" alt="App Store" /> */}
                <img src={AppleAppStore} alt="App Store" style={{ borderRadius: "6px" }} />
              </a>
            </div>
          </div>
        </section>

        {/* <!--************************************** Location Section ************************* --> */}
        {/* <section class="location">
          <div className="container">
            <div className="page_title">
              <h3>Visit Us</h3>
            </div>

            <div class="location-container">
              <div class="map">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3501.7!2d77.1!3d28.6!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjjCsDM2JzAwLjAiTiA3N8KwMDYnMDAuMCJF!5e0!3m2!1sen!2sin!4v1234567890"
                  width="100%"
                  height="450"
                  //   style="border:0;"
                  allowfullscreen=""
                  loading="lazy"
                ></iframe>
              </div>
              <div class="address">
                <h3>Shubhra Ranjan IAS</h3>
                <p>12B, Bada Baazar Road</p>
                <p>Old Rajinder Nagar</p>
                <p>New Delhi - 110060</p>
                <p>
                  Phone: <a href="tel:9810212719">9810212719</a>
                </p>
              </div>
            </div>
          </div>
        </section> */}

        <div className="our_location spacing">
          <div className="container">
            <div className="page_title">
              <h3>Visit Us</h3>
              {/* <p>{description}</p> */}
            </div>

            <div className="our_location_inn">
              <div className="content">
                <h4>{allCenters[index]?.center?.CenterName}</h4>
                <b>{allCenters[index]?.center?.City}</b>
                <ul>
                  <li>
                    <span className="icon">
                      <FaMapMarked />
                    </span>
                    <p>{allCenters[index]?.center?.Address}</p>
                  </li>
                  <li>
                    <span className="icon">
                      <FaMobileAlt />
                    </span>
                    <a href={`tel:${allCenters[index]?.center?.Phone1}`}>
                      {allCenters[index]?.center?.Phone1}
                    </a>
                  </li>
                </ul>
                <Link
                  to={
                    `/IAS_Institute_` +
                    allCenters[index]?.center?.City.replace(",", "")
                  }
                  className="button my-2"
                >
                  Go to {allCenters[index]?.center?.City} Page
                </Link>
              </div>
              <div className="map">
                <div className="center_selector">
                  <select
                    className="input dropdown_select"
                    value={index}
                    onChange={({ target }) => setIndex(target.value)}
                  >
                    {allCenters &&
                      allCenters.map(({ center, id }, i) => {
                        return (
                          <option key={id} value={i}>
                            {`${center?.CenterName}` || "N/A"}
                          </option>
                        );
                      })}
                  </select>
                </div>
                {isLoaded ? (
                  <GoogleMap
                    mapContainerStyle={containerStyle}
                    center={{
                      lat: +allCenters[index]?.latitude || 28.535517,
                      lng: +allCenters[index]?.longitude || 77.391029,
                    }}
                    zoom={mapOptions.zoom}
                    onLoad={(map) => {
                      map.setOptions({ styles: myStyles });
                    }}
                  >
                    {/* Child components, such as markers, info windows, etc. */}
                    <MarkerF
                      onLoad={onMarkerLoad}
                      position={{
                        lat: +allCenters[index]?.latitude || 28.535517,
                        lng: +allCenters[index]?.longitude || 77.391029,
                      }}
                    />

                    {/* <div className={"circle bg-danger"}>
                              <span className="circleText">SVR</span>
                            </div> */}
                  </GoogleMap>
                ) : (
                  <CourseSkeleton height={370} />
                )}
              </div>
            </div>
          </div>
        </div>

        {/* **********************************************************************************************/}
        {/* <!-- Footer --> */}
        {/* <footer>
          <div class="footer-grid">
            <div class="footer-section">
              <h3>Ventures</h3>
              <ul>
                <li>
                  <a href="#">IFH (Institute For Humanities)</a>
                </li>
              </ul>
            </div>
            <div class="footer-section">
              <h3>Help</h3>
              <ul>
                <li>
                  <a href="#">FAQs</a>
                </li>
              </ul>
            </div>
            <div class="footer-section">
              <h3>Company</h3>
              <ul>
                <li>
                  <a href="#">Our Story</a>
                </li>
                <li>
                  <a href="#">Terms & Conditions</a>
                </li>
                <li>
                  <a href="#">Privacy Policy</a>
                </li>
              </ul>
            </div>
            <div class="footer-section">
              <h3>Follow Us</h3>
              <div class="social-icons">
                <a href="#">
                  <i class="fab fa-facebook"></i>
                </a>
                <a href="#">
                  <i class="fab fa-twitter"></i>
                </a>
                <a href="#">
                  <i class="fab fa-instagram"></i>
                </a>
                <a href="#">
                  <i class="fab fa-youtube"></i>
                </a>
                <a href="#">
                  <i class="fab fa-pinterest"></i>
                </a>
                <a href="#">
                  <i class="fab fa-threads"></i>
                </a>
                <a href="#">
                  <i class="fab fa-linkedin"></i>
                </a>
              </div>
            </div>
          </div>
          <div class="footer-bottom">
            <p>&copy; 2024 Shubhra Ranjan IAS Study. All rights reserved.</p>
          </div>
        </footer> */}
        <Footer />
      </div>

      {/* ******************************************** Modals ******************************************* */}
      {/* Popup modal */}
      <Modal
        show={showSyllabus}
        onHide={() => setShowSyllabus(false)}
        size="lg"
      >
        <Modal.Header>
          <div style={{ width: "100%" }}>
            <h4 style={{ textAlign: "center" }}>{heading}</h4>
          </div>
          {/* <Modal.Title>Minutes of Meeting</Modal.Title> */}
        </Modal.Header>
        <Modal.Body style={{ height: "60vh", overflow: "auto" }}>
          <div
            style={{
              margin: "20px",
              padding: "20px",
              border: "1px solid #7986cb",
              borderRadius: "10px",
            }}
          >
            <h5>Syllabus for Main Examination</h5>
            <ul>
              <li>
                <h5>1. QUALIFYING PAPERS ON INDIAN LANGUAGES AND ENGLISH</h5>
                <p>
                  The aim of the paper is to test the candidates' ability to
                  read and understand serious discursive prose, and to express
                  ideas clearly and correctly, in English and Indian language
                  concerned. The pattern of questions would be broadly as
                  follows: Comprehension of given passages.
                </p>
                <ul>
                  <li>Precis Writing.</li>
                  <li>Usage and Vocabulary.</li>
                  <li>Short Essays.</li>
                </ul>
                <li>
                  <h5>Indian Languages:</h5>
                  <ul>
                    <li>Comprehension of given passages.</li>
                    <li>Precis Writing.</li>
                    <li>Usage and Vocabulary.</li>
                    <li>Short Essays.</li>
                  </ul>
                  <p>
                    Translation from English to the Indian Language and
                    vice-versa. Note 1: The papers on Indian Languages and
                    English will be of Matriculation or equivalent standard and
                    will be of qualifying nature only. The marks obtained in
                    these papers will not be counted for ranking. Note 2: The
                    candidates will have to answer the English and Indian
                    Languages papers in English and the respective Indian
                    language (except where translation is involved).
                  </p>
                </li>
              </li>
            </ul>

            <h5>2. PAPER-I</h5>
            <p>
              Essay: Candidates may be required to write essays on multiple
              topics. They will be expected to keep closely to the subject of
              the essay, to arrange their ideas in orderly fashion, and to write
              concisely. Credit will be given for effective and exact
              expression.
            </p>
            <h5>3. PAPER-II General Studies-I:</h5>
            <p>
              {" "}
              Indian Heritage and Culture, History and Geography of the World
              and Society. Indian culture will cover the salient aspects of Art
              Forms, literature, and Architecture from ancient to modern times.
              Modern Indian history from about the middle of the eighteenth
              century until the present - significant events, personalities,
              issues. The Freedom Struggle — its various stages and important
              contributors/contributions from different parts of the country.
              Post-independence consolidation and reorganization within the
              country. History of the world will include events from the 18th
              century such as industrial revolution, world wars, redrawal of
              national boundaries, colonization, decolonization, political
              philosophies like communism, capitalism, socialism etc.— their
              forms and effect on the society. Salient features of Indian
              Society, Diversity of India. Role of women and women’s
              organization, population and associated issues, poverty and
              developmental issues, urbanization, their problems and their
              remedies. Effects of globalization on Indian society. Social
              empowerment, communalism, regionalism & secularism. Salient
              features of world’s physical geography. Distribution of key
              natural resources across the world (including South Asia and the
              Indian sub-continent); factors responsible for the location of
              primary, secondary, and tertiary sector industries in various
              parts of the world (including India). Important Geophysical
              phenomena such as earthquakes, Tsunami, Volcanic activity, cyclone
              etc., geographical features and their location - changes in
              critical geographical features (including water-bodies and
              ice-caps) and in flora and fauna and the effects of such changes.
            </p>
            <h5>4. PAPER-III General Studies-II:</h5>
            <p>
              {" "}
              Governance, Constitution, Polity, Social Justice, and
              International relations. Indian Constitution—historical
              underpinnings, evolution, features, amendments, significant
              provisions, and basic structure. Functions and responsibilities of
              the Union and the States, issues and challenges pertaining to the
              federal structure, devolution of powers and finances up to local
              levels and challenges therein. Separation of powers between
              various organs, dispute redressal mechanisms, and institutions.
              Comparison of the Indian constitutional scheme with that of other
              countries. Parliament and State legislatures—structure,
              functioning, conduct of business, powers & privileges and issues
              arising out of these. Structure, organization and functioning of
              the Executive and the Judiciary—Ministries and Departments of the
              Government; pressure groups and formal/informal associations and
              their role in the Polity. Salient features of the Representation
              of People’s Act. Appointment to various Constitutional posts,
              powers, functions, and responsibilities of various Constitutional
              Bodies. Statutory, regulatory, and various quasi-judicial bodies.
              Government policies
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            gap: "10px",
          }}
        >
          <Button
            variant="outline-secondary"
            style={{ cursor: "pointer" }}
            onClick={() => setShowSyllabus(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Features Modal */}
      <Modal
        show={showFeatures}
        onHide={() => setShowFeatures(false)}
        size="lg"
      >
        <Modal.Header>
          <div style={{ width: "100%" }}>
            <h4 style={{ textAlign: "center" }}>{heading}</h4>
          </div>
        </Modal.Header>
        <Modal.Body style={{ height: "60vh", overflow: "auto" }}>
          <div
            style={{
              margin: "20px",
              padding: "20px",
              border: "1px solid #7986cb",
              borderRadius: "10px",
            }}
          >
            <ul style={{ listStyleType: "circle", padding: "0 20px" }}>
              <li>Precis Writing.</li>
              <li>Usage and Vocabulary.</li>
              <li>Short Essays.</li>
              <li>Comprehension of given passages.</li>
              <li>Precis Writing.</li>
              <li>Usage and Vocabulary.</li>
              <li>Short Essays.</li>
              <li>Understand semantic HTML structure.</li>
              <li>Use descriptive class and ID names.</li>
              <li>Keep your CSS DRY (Don’t Repeat Yourself).</li>
              <li>Leverage CSS variables for theming.</li>
              <li>Normalize or reset browser defaults.</li>
              <li>Mobile-first, responsive design approach.</li>
              <li>Use flexbox for one-dimensional layouts.</li>
              <li>Use grid for two-dimensional layouts.</li>
              <li>Optimize media queries’ breakpoints.</li>
              <li>Minify and concatenate your CSS files.</li>
              <li>Use shorthand properties where possible.</li>
              <li>Prefer `rem`/`em` over `px` for scalability.</li>
              <li>Keep specificity low—use classes, not inline styles.</li>
              <li>Use `:root` to declare global CSS variables.</li>
              <li>Organize your stylesheet (e.g. base, layout, components).</li>
              <li>Leverage pseudo-classes (`:hover`, `:focus`, etc.).</li>
              <li>
                Use pseudo-elements (`::before`, `::after`) for decorative
                content.
              </li>
              <li>Optimize performance: limit use of expensive selectors.</li>
              <li>Avoid deep nesting in preprocessors (Sass, Less).</li>
              <li>Use `will-change` sparingly for smooth animations.</li>
              <li>Include accessible focus styles for interactive elements.</li>
              <li>Test in multiple browsers (and older versions if needed).</li>
              <li>Use SVG or icon fonts for crisp icons at any resolution.</li>
              <li>Lazy-load offscreen images and assets.</li>
              <li>Keep CSS files version-controlled and well-documented.</li>
            </ul>
          </div>
        </Modal.Body>
        <Modal.Footer
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            gap: "10px",
          }}
        >
          <Button
            variant="outline-secondary"
            style={{ cursor: "pointer" }}
            onClick={() => setShowFeatures(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* *************** Show Path ****************** */}
      <Modal show={showPath} onHide={() => setShowPath(false)} size="lg">
        <Modal.Header>
          <div style={{ width: "100%" }}>
            <h4 style={{ textAlign: "center" }}>{heading}</h4>
          </div>
          {/* <Modal.Title>Minutes of Meeting</Modal.Title> */}
        </Modal.Header>
        <Modal.Body style={{ height: "60vh", overflow: "auto" }}>
          <div
            style={{
              margin: "20px",
              padding: "20px",
              border: "1px solid #7986cb",
              borderRadius: "10px",
            }}
          >
            <ul style={{ listStyleType: "circle", padding: "0 20px " }}>
              <li>Precis Writing.</li>
              <li>Usage and Vocabulary.</li>
              <li>Short Essays.</li>
              <li>Comprehension of given passages.</li>
              <li>Precis Writing.</li>
              <li>Usage and Vocabulary.</li>
              <li>Short Essays.</li>
              <li>Understand semantic HTML structure.</li>
              <li>Use descriptive class and ID names.</li>
              <li>Keep your CSS DRY (Don’t Repeat Yourself).</li>
              <li>Leverage CSS variables for theming.</li>
              <li>Normalize or reset browser defaults.</li>
              <li>Mobile-first, responsive design approach.</li>
              <li>Use flexbox for one-dimensional layouts.</li>
              <li>Use grid for two-dimensional layouts.</li>
              <li>Optimize media queries’ breakpoints.</li>
              <li>Minify and concatenate your CSS files.</li>
              <li>Use shorthand properties where possible.</li>
              <li>Prefer `rem`/`em` over `px` for scalability.</li>
              <li>Keep specificity low—use classes, not inline styles.</li>
              <li>Use `:root` to declare global CSS variables.</li>
              <li>Organize your stylesheet (e.g. base, layout, components).</li>
              <li>Leverage pseudo-classes (`:hover`, `:focus`, etc.).</li>
              <li>
                Use pseudo-elements (`::before`, `::after`) for decorative
                content.
              </li>
              <li>Optimize performance: limit use of expensive selectors.</li>
              <li>Avoid deep nesting in preprocessors (Sass, Less).</li>
              <li>Use `will-change` sparingly for smooth animations.</li>
              <li>Include accessible focus styles for interactive elements.</li>
              <li>Test in multiple browsers (and older versions if needed).</li>
              <li>Use SVG or icon fonts for crisp icons at any resolution.</li>
              <li>Lazy-load offscreen images and assets.</li>
              <li>Keep CSS files version-controlled and well-documented.</li>
            </ul>
          </div>
        </Modal.Body>
        <Modal.Footer
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            gap: "10px",
          }}
        >
          <Button
            variant="outline-secondary"
            style={{ cursor: "pointer" }}
            onClick={() => setShowPath(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
